import { Button, Card, Container, Divider, Grid, Tooltip, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { withAuthorization } from "../Session";
import { GoogleMap, useJsApiLoader, Marker, LoadScript } from "@react-google-maps/api";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";

import {
  Battery80Outlined,
  Battery90Outlined,
  BatteryAlert,
  Battery70Outlined,
  BatteryAlertOutlined,
  BatteryFullOutlined,
  HomeOutlined,
  LocationOn,
  LocationOnOutlined,
  RoundedCorner,
  Battery60Outlined,
  Battery50Outlined,
  Battery30Outlined,
  Battery20Outlined,
  BatteryChargingFullOutlined,
  BatteryCharging90Outlined,
  BatteryCharging80Outlined,
  BatteryCharging60Outlined,
  BatteryCharging50Outlined,
  BatteryCharging30Outlined,
  BatteryCharging20Outlined,
} from "@material-ui/icons";
import { blue, green, grey, orange, red } from "@material-ui/core/colors";

const AlertScreen = (props) => {
  let { key } = useParams();
  const history = useHistory();
  const { firebase } = props;

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [startTime, setStartTime] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [lastCommunication, setLastCommunication] = useState(0);
  const [eventList, setEventList] = useState([]);
  const [alertEnd, setAlertEnd] = useState(false);

  const timerRef = useRef(null);

  useEffect(() => {
    firebase
      .alertRef()
      .child(key)
      .once("value")
      .then((snap) => {
        setData(snap.val());
        setIsLoading(false);
        if (!!snap.val()) {
          setStartTime(snap.val().start);
          //setEventList(snap.val().events.reverse());
        }
      });
    var onChildRemoved = firebase
      .alertRef()
      .child(key)
      .on("child_removed", () => setAlertEnd(true));

    return firebase.alertRef().off("child_removed", onChildRemoved);
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setElapsedTime(parseInt((new Date().getTime() - startTime) / 1000));
    }, 1000);

    const lastComRef = firebase.alertRef().child(key).child("lastMessage");
    const eventRef = firebase.alertRef().child(key).child("events");
    var onlastValue = lastComRef.on("value", (childSnapshot, prevChildKey) => setLastCommunication(childSnapshot.val()));
    var oneventValue = eventRef.on("value", (childSnapshot, prevChildKey) => !!childSnapshot.val() && setEventList(childSnapshot.val().reverse()));

    return () => {
      clearInterval(timerRef.current);
      lastComRef.off("value", onlastValue);
      eventRef.off("value", oneventValue);
    };
  }, [startTime]);

  useEffect(() => {
    if (alertEnd) {
      clearInterval(timerRef.current);
    }
  }, [alertEnd]);

  return (
    <Grid container justifyContent="center">
      <Grid container spacing={4} item xs={12} lg={10}>
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant="h4" color="primary">
            Panel de alerta
          </Typography>
          <Typography variant="h5" color="textSecondary">
            Alerta enviada por: {key}
          </Typography>
          {alertEnd && (
            <Typography variant="h5" color="error">
              Alerta finalizada
            </Typography>
          )}
        </Grid>

        {isLoading ? (
          <Typography>Cargando</Typography>
        ) : !!data ? (
          <AlertBody
            firebase={firebase}
            key={key}
            data={{
              ...data,
              deviceId: key,
              elapsedTime: elapsedTime,
              lastMessage: lastCommunication,
              events: eventList,
            }}
          />
        ) : (
          <Grid container alignContent="center" alignItems="center">
            <Typography>Los datos no estan disponibles, vuelve a la vista anterior</Typography>
            <Button
              variant="contained"
              onClick={() => {
                history.push(ROUTES.REAL_TIME_ALERS);
              }}
            >
              Volver
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(AlertScreen);

const AlertBody = ({ data, firebase }) => {
  const stopAlertForVolunteers = async () => {
    try {
      const idToken = await firebase.auth.currentUser.getIdToken(true);
      const response = await fetch("https://europe-west1-reanibex-training.cloudfunctions.net/alertEnd", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deviceId: data.deviceId,
          idToken: idToken,
        }),
      });

      const result = await response.text();
      if (response.ok) {
      } else {
        console.error("❌ Error al detener alerta:", result);
      }
    } catch (err) {
      console.error("❌ Error en llamada a alertEnd:", err);
    }
  };

  return (
    <Grid container item xs={12} spacing={2} direction="row">
      <Grid container item xs={12} md={9} spacing={2} alignContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h6" color="primary">
            Datos del evento
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card style={{ padding: 16 }}>
            <Grid container direction="column" item xs={12}>
              <Typography variant="body1">Programa : {data.programId}</Typography>
              <Typography variant="body1">Grupo : {data.groupId}</Typography>
              <Typography variant="body1">Dispositivo: {data.deviceId}</Typography>
            </Grid>
          </Card>
        </Grid>

        <Grid item xs={12} md={5}>
          <Card style={{ padding: 16 }}>
            <Grid container direction="column" item xs={12}>
              <Typography variant="body1">Tiempo inicio :{moment(data.start).format("DD/MM/YYYY HH:mm:ss")}</Typography>
              <Typography variant="body1">{` Tiempo transcurrido : ${parseInt(data.elapsedTime / 60)}:${data.elapsedTime % 60} Segundos`}</Typography>
              <Typography variant="body1">{` Ultimo mensaje: ${moment(data.lastMessage).format("DD/MM/YYYY HH:mm:ss")}`}</Typography>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} container>
            <Typography variant="h6" color="primary">
              Rescatadores
            </Typography>
          </Grid>
          <Grid item xs={12} container>
            <Google_Map firebase={firebase} data={data} />
          </Grid>
          <Grid item container spacing={1}>
            {!!data.rescuersTokenDistance && Object.keys(data.rescuersTokenDistance).map((t) => <RescuerCard token={t} firebase={firebase} data={data} />)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={3} container spacing={3} alignContent="flex-start">
        <Grid item xs={12}>
          <Typography variant="h6" color="primary">
            Acciones
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="contained"
            style={{
              height: 100,
              color: red[200],
              backgroundColor: red[500],
              textTransform: "none",
            }}
            onClick={stopAlertForVolunteers}
          >
            <Typography style={{ color: "white" }}> Detener alerta</Typography>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" color="primary">
            Log de eventos
          </Typography>
        </Grid>
        {data.events.map((e) => (
          <Grid item xs={12}>
            <Card style={{ padding: 16 }}>
              <Grid item xs={12}>
                <Typography>Tipo de evento {e.code}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{`Fecha: ${moment(e.time).format("DD/MM/YYYY HH:mm:ss")}`}</Typography>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

const Google_Map = ({ firebase, data }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [coords, setCoords] = useState({ lat: 43.186879, lng: -2.504057 });
  const [zoom, setZoom] = useState(16);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    map.setCenter({ lat: data?.currentLocation?.deviceLocation?.latitude, lng: data?.currentLocation?.deviceLocation?.longitude });
  }, []);

  const onUnmount = React.useCallback(function callback(map) {}, []);

  const mapReference = useRef(null);

  const center = {
    lat: -3.745,
    lng: -38.523,
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "400px" }}
      onLoad={onLoad}
      ref={mapReference}
      options={{ maxZoom: 19 }}
      center={{ lat: data?.currentLocation?.deviceLocation?.latitude, lng: data?.currentLocation?.deviceLocation?.longitude }}
      position={{ lat: data?.currentLocation?.deviceLocation?.latitude, lng: data?.currentLocation?.deviceLocation?.longitude }}
      onUnmount={onUnmount}
      onDragEnd={(e) => console.log(e)}
    >
      {/* Child components, such as markers, info windows, etc. */}
      {!!data.rescuersTokenDistance && Object.keys(data.rescuersTokenDistance).map((t) => <RescuerMarker token={t} firebase={firebase} data={data} />)}
      <Marker
        label={"AED"}
        position={{
          lat: data?.currentLocation?.deviceLocation?.latitude,
          lng: data?.currentLocation?.deviceLocation?.longitude,
        }}
      />
    </GoogleMap>
  ) : (
    <></>
  );
};

const RescuerCard = ({ token, firebase, data }) => {
  const [lastLog, setLastLog] = useState({ type: "NAM0", time: 0 });
  const [stateColor, setStateColor] = useState(red[300]);
  const [deviceData, setDeviceData] = useState({});

  useEffect(() => {
    const logRef = firebase.alertRef().child(data.deviceId).child(`rescuersLog/${token}/log`);
    var onlogChild = logRef.on("child_added", (snap, prevKey) => setLastLog(snap.val()));

    const DEVICE_DATA_REF = firebase.alertRef().child(data.deviceId).child(`rescuersData/${token}`);
    DEVICE_DATA_REF.once("value").then((snap) => setDeviceData(snap.val()));

    return () => {
      logRef.off("child_added", onlogChild);
    };
  }, []);

  useEffect(() => {
    const c = lastLog.type.split("NAM")[1];
    const correct = ["1", "2", "4", "5", "5.1", "5.2", "9", "10.2"];
    const warning = ["3", "7", "10", "11.1", "11.2"];
    const error = ["0", "6", "10.1", "11"];
    const finish = ["8"];

    if (correct.includes(c)) {
      setStateColor(green[300]);
    } else if (warning.includes(c)) {
      setStateColor(orange[300]);
    } else if (error.includes(c)) {
      setStateColor(red[300]);
    } else {
      setStateColor(blue[300]);
    }
  }, [lastLog]);

  return (
    <Grid item xs={12} md={4}>
      <Card style={{ padding: 16, backgroundColor: stateColor }}>
        <Grid container spacing={1}>
          <Grid container justify="space-between">
            <Tooltip title={<Typography variant="body1"> {token} </Typography>} placement="top">
              <Typography variant="body1" color="textPrimary">
                {deviceData?.owner?.email} · {deviceData?.owner?.uid}
              </Typography>
            </Tooltip>
          </Grid>

          <Grid item xs={12} container direction="column" alignItems="flex-start" justify="center">
            <Tooltip title={<Typography variant="body1">{lastLog.type == "NAM0" ? "No se ha obtenido respuesta del dispositivo" : lastLog.action}</Typography>} placement="top">
              <Typography variant="body1">Última comunicación: {moment(lastLog.time).format("HH:mm:ss")}</Typography>
            </Tooltip>
            <Typography variant="body2" color="textPrimary">
              {`Localizado: ${deviceData?.deviceLocationProvided ? "SI" : "NO"}`}
            </Typography>
            <Typography variant="body2" color="textPrimary">
              {`Disp.: ${deviceData?.deviceName}`}
            </Typography>
            <Typography variant="body2" color="textPrimary">
              {`V_App: ${deviceData?.appVersion}`}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

const RescuerMarker = ({ firebase, token, data }) => {
  const [location, setLocation] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const positionRef = firebase.alertRef().child(data.deviceId).child(`rescuersLog/${token}/lastKnownPosition`);

    var onPositionValue = positionRef.on("value", (snap, prevKey) => {
      if (!!snap.val()) {
        setLocation({ lat: snap.val().latitude, lng: snap.val().longitude });
        setIsLoaded(true);
      }
    });

    return () => {
      positionRef.off("value", onPositionValue);
    };
  }, []);

  return !isLoaded ? (
    <></>
  ) : (
    <Marker
      position={location}
      icon={{
        path: "M16.5,5.5A2,2 0 0,0 18.5,3.5A2,2 0 0,0 16.5,1.5A2,2 0 0,0 14.5,3.5A2,2 0 0,0 16.5,5.5M12.9,19.4L13.9,15L16,17V23H18V15.5L15.9,13.5L16.5,10.5C17.89,12.09 19.89,13 22,13V11C20.24,11.03 18.6,10.11 17.7,8.6L16.7,7C16.34,6.4 15.7,6 15,6C14.7,6 14.5,6.1 14.2,6.1L9,8.3V13H11V9.6L12.8,8.9L11.2,17L6.3,16L5.9,18L12.9,19.4M4,9A1,1 0 0,1 3,8A1,1 0 0,1 4,7H7V9H4M5,5A1,1 0 0,1 4,4A1,1 0 0,1 5,3H10V5H5M3,13A1,1 0 0,1 2,12A1,1 0 0,1 3,11H7V13H3Z",
        anchor: { x: 15, y: 15 },
        fillColor: grey[400],
        fillOpacity: 0.9,
        scale: 1.25,
        strokeColor: "black",
        strokeWeight: 1,
      }}
    ></Marker>
  );
};
